import React from 'react';
import Link from 'next/link';
import css from './Footer.less';

const brandLogo = require('~/static/common/brand@3x.png');

const navLinks = [
  { label: '关于我们', href: '/about' },
  { label: '工作机会', href: '/join' },
  { label: '商务合作', href: '/contact' },
  {
    label: '服务商入口',
    href: 'http://www.xindebaby.com/thrid/providers/',
    external: true,
  },
];

const icpList = [
  { label: '京ICP证京B2-20170357' },
  { label: '京ICP备16013191号', href: 'https://beian.miit.gov.cn/' },
  {
    label: '京公网安备11010502031656号',
    href: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502031655',
  },
  {
    label: '互联网药品信息服务资格证编号(京)-经营性-2019-0029',
    href: 'http://weapp-assets.xindebaby.com/web_certificate_213.jpeg',
  },
];

const disclaimer =
  '本公司展示的保险产品均来自于以下四家中介类保险代理公司，并且进行了信息披露和报备。四家公司分别为：保通保险代理有限公司、慧择保险经纪有限公司、小雨伞保险经纪有限公司、科成保险代理有限公司。';

const Footer = () => {
  return (
    <footer className={css.footer}>
      <div className={css.container}>
        <div className={css.topRow}>
          <img className={css.logo} src={brandLogo} alt="新得宝贝" />
        </div>

        <nav className={css.nav}>
          {navLinks.map(link => {
            if (link.external) {
              return (
                <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.label}
                </a>
              );
            }
            return (
              <Link key={link.label} href={link.href}>
                <a>{link.label}</a>
              </Link>
            );
          })}
        </nav>

        <div className={css.meta}>
          <p>© {new Date().getFullYear()} 北京新得科技有限公司 版权所有</p>
          <p>北京市朝阳区八里庄西里98号98号楼18层2103号</p>
          <div className={css.icpRow}>
            {icpList.map(item => {
              if (item.href) {
                return (
                  <a key={item.label} href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.label}
                  </a>
                );
              }
              return (
                <span key={item.label} className={css.icpItem}>
                  {item.label}
                </span>
              );
            })}
          </div>
        </div>

        <p className={css.disclaimer}>{disclaimer}</p>
      </div>
    </footer>
  );
};

export default Footer;
